import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";
import AdmissionContext from "../AdmissionContext";
import { ShowRequiredField, kPButton, HighSchoolList } from "../global";

class SchoolView extends Component {
  static contextType = AdmissionContext;

  constructor(props) {
    super(props);

    // { description: "Senior High School" }, 
    // { description: "High School" }, 
    // { description: "ALS" }

    this.state = {
      strand: [],
      highschool: {description: 'Senior High School'}
    };
  }

  textfieldValueChanged = (index, event) => {
    const { school } = this.context;
    school.required = false;

    if (index === 0) {
      school.gradIntermediate = event.target.value;

    } else if (index === 1) {
      //shsName
      school.shsName = event.target.value;
      school.gradShs = event.target.value;

    } else if (index === 2) {
      //shsAddress
      school.shsAddress = event.target.value;
    } else if (index === 3) {
      //lrn
      school.lrn = event.target.value;
    } else if (index === 4) {
      //collegeCourse
      school.collegeCourse = event.target.value;
      school.gradCollege = event.target.value;

    } else if (index === 5) {
      //collegeName
      school.collegeName = event.target.value;
    } else if (index === 6) {
      //collegeAddress
      school.collegeAddress = event.target.value;
    } else if (index === 7) {
      //gradHighestYearCompleted
      school.gradHighestYearCompleted = event.target.value;
    } else if (index === 8) {
      //gradLastSchoolAttended
      school.gradLastSchoolAttended = event.target.value;
    }

    this.context.SetSchool(school);
  };

  trackValueChanged = (event, value) => {
    const { school } = this.context;
    school.required = false;
    school.shsTrack = value;
    school.shsStrand = null;
    this.context.SetSchool(school);

    //load strand
    if (value === null) {
      this.setState({
        strand: [],
      });
    } else {
      this.setState({
        strand: school.shsTrack.strand,
      });
    }
  };

  strandValueChanged = (event, value) => {
    const { school } = this.context;
    school.required = false;
    school.shsStrand = value;
    this.context.SetSchool(school);
  };

  highSchoolValueChanged = (event, value) => {
    this.setState({
      highschool: value,
    });
  };

  inclusiveDateValueChanged = (index, value) => {

    const { school } = this.context;
    school.required = false;

    var tmpDate = null;
    if (value !== null) {
      tmpDate = moment(value).format("MM/DD/YYYY")
    }

    if (index === 0) {
      school.gradIntermediateYear = tmpDate;

    } else if (index === 1) {

      school.shsInclusiveDate = tmpDate;
      school.gradShsYear = tmpDate;

    } else if (index === 2) {
      school.collegeInclusiveDate = tmpDate;
      school.gradCollegeYear = tmpDate;

    }

    this.context.SetSchool(school);
  };

  checkRequireFields = (index) => {
    const { school } = this.context;

    if (school.required) {

      if (index === 0) {
        if (school.gradIntermediate === "") {
          return ShowRequiredField("School Name");
        }
      } else if (index === 1) {
        if (school.gradIntermediateYear === "" || school.gradIntermediateYear === null) {
          return ShowRequiredField("Year Graduated");
        }
      } else if (index === 2) {
        if (school.shsName === "") {
          return ShowRequiredField("School Name");
        }
      } else if (index === 3) {
        if (school.shsAddress === "") {
          return ShowRequiredField("Address");
        }
      } else if (index === 4) {
        if (school.shsInclusiveDate === "" || school.shsInclusiveDate === null) {
          return ShowRequiredField("Year Graduated");
        }
      }

    }

    return null;
  };

  showHighSchool = () => {

    const { school, track } = this.context;
    console.log('showHighSchool 1')
    console.log(this.state.highschool)
    console.log('showHighSchool 2')

    if(this.state.highschool == null)  return null 
    if (this.state.highschool.description != "Senior High School") return null

    return (
      <div>
        <Box pt={2}>
          <Autocomplete
            id="cboTrack"
            options={track}
            value={school.shsTrack}
            getOptionLabel={(item) => item.description}
            fullWidth={true}
            onChange={this.trackValueChanged}
            renderInput={(params) => (
              <TextField {...params} label="Track" variant="outlined" />
            )}
          />
        </Box>


        <Box pt={2}>
          <Autocomplete
            id="cboStrand"
            options={this.state.strand}
            value={school.shsStrand}
            getOptionLabel={(item) => item.description}
            fullWidth={true}
            onChange={this.strandValueChanged}
            renderInput={(params) => (
              <TextField {...params} label="Strand" variant="outlined" />
            )}
          />
        </Box>
      </div>
    )

  }

  backButtonClicked = () => {
    this.context.btnBackClicked();
  };

  nextButtonClicked = () => {
    const { school } = this.context;

    if (
      school.gradIntermediate === "" ||
      school.gradIntermediateYear === "" ||
      school.gradIntermediateYear === null ||
      school.shsName === "" ||
      school.shsAddress === "" ||
      school.shsInclusiveDate === "" ||
      school.shsInclusiveDate === null
    ) {
      school.required = true;
      this.context.SetSchool(school);
      return;
    }


    this.context.btnNextClicked();
  };

  render() {
    const { school, track } = this.context;

    return (
      <Box display="flex" justifyContent="center" pt={2}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Card
              style={{
                border: 0,
                // minWidth: 500,
                // maxWidth: 600,
              }}
              variant="outlined"
            >
              <CardContent>
                <Box>
                  <Typography component="div">
                    <Box
                      fontWeight={500}
                      fontSize={18}
                      color="#388e3c"
                      display="flex"
                      justifyContent="flex-start"
                    >
                      Elementary
                    </Box>
                  </Typography>

                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtSchoolName"
                      label="School Name"
                      variant="outlined"
                      value={school.gradIntermediate}
                      onChange={(e) => {
                        this.textfieldValueChanged(0, e);
                      }}
                    />
                  </Box>

                  {this.checkRequireFields(0)}

                  <Box pt={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="dtpIntermediateInclusiveDate"
                        label="Year Graduated"
                        format="MM/dd/yyyy"
                        value={school.gradIntermediateYear}
                        onChange={(e) => this.inclusiveDateValueChanged(0, e)}
                        inputVariant="outlined"
                        fullWidth={true}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Box>

                  {this.checkRequireFields(1)}

                  {/* high school */}
                  <Typography component="div">
                    <Box
                      fontWeight={500}
                      fontSize={18}
                      color="#388e3c"
                      display="flex"
                      justifyContent="flex-start"
                      pt={3}
                    >
                      High School
                    </Box>
                  </Typography>

                  <Box pt={2}>
                    <Autocomplete
                      id="cboHighSchool"
                      options={HighSchoolList}
                      value={this.state.highschool}
                      getOptionLabel={(item) => item.description}
                      fullWidth={true}
                      onChange={this.highSchoolValueChanged}
                      renderInput={(params) => (
                        <TextField {...params} label="High School" variant="outlined" />
                      )}
                    />
                  </Box>



                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtSchoolName"
                      label="School Name"
                      variant="outlined"
                      value={school.shsName}
                      onChange={(e) => {
                        this.textfieldValueChanged(1, e);
                      }}
                    />
                  </Box>

                  {/* shsName */}
                  {this.checkRequireFields(2)}

                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtSchoolAddress"
                      label="School Address"
                      variant="outlined"
                      value={school.shsAddress}
                      onChange={(e) => {
                        this.textfieldValueChanged(2, e);
                      }}
                    />
                  </Box>

                  {/* shsAddress */}
                  {this.checkRequireFields(3)}

                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtLRN"
                      label="LRN"
                      variant="outlined"
                      value={school.lrn}
                      onChange={(e) => {
                        this.textfieldValueChanged(3, e);
                      }}
                    />
                  </Box>

                  {this.showHighSchool()}

                  <Box pt={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="dtpshsInclusiveDate"
                        label="Year Graduated"
                        format="MM/dd/yyyy"
                        value={school.shsInclusiveDate}
                        onChange={(e) => this.inclusiveDateValueChanged(1, e)}
                        inputVariant="outlined"
                        fullWidth={true}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Box>

                  {/* shsInclusiveDate */}
                  {this.checkRequireFields(4)}


                  <Typography component="div">
                    <Box
                      fontWeight={500}
                      fontSize={18}
                      color="#388e3c"
                      display="flex"
                      justifyContent="flex-start"
                      pt={3}
                    >
                      College (if any)
                    </Box>
                  </Typography>

                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtCollegeCourse"
                      label="Course/Program"
                      variant="outlined"
                      value={school.collegeCourse}
                      onChange={(e) => {
                        this.textfieldValueChanged(4, e);
                      }}
                    />
                  </Box>

                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtCollegeSchooName"
                      label="School Name"
                      variant="outlined"
                      value={school.collegeName}
                      onChange={(e) => {
                        this.textfieldValueChanged(5, e);
                      }}
                    />
                  </Box>

                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtCollegeSchooAddress"
                      label="School Address"
                      variant="outlined"
                      value={school.collegeAddress}
                      onChange={(e) => {
                        this.textfieldValueChanged(6, e);
                      }}
                    />
                  </Box>

                  <Box pt={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="dtpDateofBirth"
                        label="Inclusive Dates"
                        format="MM/dd/yyyy"
                        value={school.collegeInclusiveDate}
                        onChange={(e) => this.inclusiveDateValueChanged(2, e)}
                        inputVariant="outlined"
                        fullWidth={true}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Box>

                  <Typography component="div">
                    <Box
                      fontWeight={500}
                      fontSize={18}
                      color="#388e3c"
                      display="flex"
                      justifyContent="flex-start"
                      pt={3}
                    >
                      Other
                    </Box>
                  </Typography>

                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtHighestYearCompleted"
                      label="Highest Year Completed"
                      variant="outlined"
                      value={school.HighestYearCompleted}
                      onChange={(e) => {
                        this.textfieldValueChanged(7, e);
                      }}
                    />
                  </Box>

                  <Box pt={2}>
                    <TextField
                      fullWidth={true}
                      id="txtLastSchoolAttended"
                      label="Last School Attended"
                      variant="outlined"
                      value={school.LastSchoolAttended}
                      onChange={(e) => {
                        this.textfieldValueChanged(8, e);
                      }}
                    />
                  </Box>

                </Box>

                {/* BUTTON         */}
                <Box
                  justifyContent="center"
                  display="flex"
                  pt={3}
                  fontSize={14}
                >
                  <Box width={200} justifyContent="flex-start">
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.backButtonClicked();
                      }}
                    >
                      Back
                    </Button>
                  </Box>

                  <Box width={200} minHeight={100} pl={2}>
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.nextButtonClicked();
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>
      </Box>
    );
  }

}

export default SchoolView;
